import "./main-app.css";
import React, { useEffect, useState, useContext } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { MainContext } from "../../../App";
import { SideNav } from "../side-nav/side-nav";
import { Header } from "../header/header";
import { Home } from "../../../features/common/home/home";
import { FrontOfficeDashboard } from "../../../features/front-office/dashboard/front-office-dashboard";
import { BackOfficeDashboard } from "../../../features/back-office/dashboard/back-office-dashboard";
import { Transactions } from "../../../features/back-office/transactions/transactions";
import { RequeryManagement } from "../../../features/back-office/requery-management/requery-management";
import { BackofficeTransactionReports } from "../../../features/back-office/transaction-reports/transaction-reports";
import { FrontofficeTransactionReports } from "../../../features/front-office/transaction-reports/transaction-reports";
import { FrontOfficeTransactions } from "../../../features/front-office/transactions/front-office-transactions";
import { BulkSettlements } from "../../../features/back-office/bulk-settlements/bulk-settlements";
import { FrontOfficeBulkSettlement } from "../../../features/front-office/bulk-settlement/front-office-bulk-settlement";
import { FrontOfficeSuperAgentUsers } from "../../../features/front-office/super-agent-user/front-office-super-agent-users";
import { SuperAgents } from "../../../features/back-office/super-agents/super-agents";
import { BackofficeDisputes } from "../../../features/back-office/disputes/backoffice-disputes";
import { BackofficeSuperagentDisputes } from "../../../features/back-office/disputes/superagent-disputes";
import { ManualDisputeRefunds } from "../../../features/back-office/manual-payments/manual-dispute-refunds";
import { ManualSettlementPayments } from "../../../features/back-office/manual-payments/manual-settlement-payments";
import { FrontOfficeAgentDisputes } from "../../../features/front-office/disputes/agent-disputes";
import { FrontOfficeBankDisputes } from "../../../features/front-office/disputes/bank-disputes";
import { BulkDisputeResponse } from "../../../features/front-office/bulk-dispute-response/bulk-dispute-response";
import { SuperAgentUsers } from "../../../features/back-office/super-agent-users/super-agent-users";
import { ChargeTypes } from "../../../features/back-office/charge-types/charge-types";
import { Participants } from "../../../features/back-office/participants/participants";
import { PublicHolidays } from "../../../features/back-office/public-holidays/public-holidays";
import { Configurations } from "../../../features/back-office/configurations/configurations";
import { ChangePassword } from "../../elements/change-password/change-password";
import { UserManagement } from "../../../features/back-office/user-management/user-management";
import { ParticipantUsers } from "../../../features/back-office/participant-users/participant-users";
import { ParticipantReports } from "../../../features/back-office/participant-reports/participant-reports";
import { AllWorkflowRequests } from "../../../features/back-office/workflow/all-workflow-requests";
import { SelfWorkflowRequests } from "../../../features/back-office/workflow/self-workflow-requests";
import { UploadedReconciliationFiles } from "../../../features/back-office/reconciliation/statement-upload/uploaded-files";
import { ReconciliationDailyUploads } from "../../../features/back-office/reconciliation/daily-uploads/daily-upload";
import { CreditReconciliation } from "../../../features/back-office/reconciliation/credit-debit-reconciliation/credit-reconciliation";
import { DebitReconciliation } from "../../../features/back-office/reconciliation/credit-debit-reconciliation/debit-reconciliation";
import { ReconciliationConfigurations } from "../../../features/back-office/reconciliation/configurations/reconciliation-configurations";
import { BulkDisputes } from "../../../features/back-office/bulk-disputes/bulk-disputes";
import { TransitAccounts } from "../../../features/back-office/transit-account-setup/transit-accounts";
import { PageNotFound } from "../../../features/common/404/404-page";
import { API_SERVICE } from "../../../api/service";
import { COMMON_API } from "../../../api/routes/common/index";
import { STORAGE } from "../../../utils/storage";
import * as webStorage from "../../../utils/webStorage";
import { SettlementRuleConfigs } from "features/back-office/settlement-rule-configs/settlement-rule-configs";

export const MainApp = () => {
  const [idleTimeInMinutes] = useState(5);
  const mainContext = useContext(MainContext);
  let history = useHistory();

  useEffect(() => {
    function setIdleTime() {
      const idleTimeInMilliseconds = idleTimeInMinutes * 60 * 1000;
      webStorage.setItem("_expiredTime", Date.now() + idleTimeInMilliseconds);
    }
    window.addEventListener("click", setIdleTime);
    window.addEventListener("mousemove", setIdleTime);
    window.addEventListener("scroll", setIdleTime);
    window.addEventListener("keydown", setIdleTime);

    function logout() {
      const url = COMMON_API.AUTH.LOGOUT;
      API_SERVICE.MAKE_PUT_REQUEST(url, null)
        .then(() => {
          mainContext.mainDispatch({ type: "LOG_OUT" });
          STORAGE.CLEAR_STORAGE();
          history.push("/login");
        })
        .catch(() => {
          mainContext.mainDispatch({ type: "LOG_OUT" });
          STORAGE.CLEAR_STORAGE();
          history.push("/login");
        });
    }

    setIdleTime();
    const interval = setInterval(() => {
      const expiredTime = webStorage.getItem("_expiredTime");
      if (expiredTime < Date.now()) {
        mainContext.mainDispatch({
          type: "SET_ALERT",
          alert: {
            title: "Info",
            description: "Your session has timed out, please login again.",
            type: "error",
            showAlert: true,
          },
        });
        logout();
      }
    }, 1000);
    return () => {
      clearInterval(interval);
      window.removeEventListener("click", setIdleTime);
      window.removeEventListener("mousemove", setIdleTime);
      window.removeEventListener("scroll", setIdleTime);
      window.removeEventListener("keydown", setIdleTime);
    };
  }, [history, idleTimeInMinutes, mainContext]);

  return (
    <div>
      <div>
        <SideNav />
      </div>
      <div id="main">
        <div>
          <Header />
        </div>
        <div className="main-body inner-content">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route
              exact
              path="/front-office/dashboard"
              component={FrontOfficeDashboard}
            />
            <Route
              exact
              path="/back-office/dashboard"
              component={BackOfficeDashboard}
            />
            -
            <Route path="/back-office/transactions" component={Transactions} />
            <Route
              path="/back-office/requery-management"
              component={RequeryManagement}
            />
            <Route
              path="/back-office/transaction-reports"
              component={BackofficeTransactionReports}
            />
            <Route
              path="/front-office/transaction-reports"
              component={FrontofficeTransactionReports}
            />
            <Route
              path="/front-office/transactions"
              component={FrontOfficeTransactions}
            />
            <Route
              path="/back-office/bulk-settlements"
              component={BulkSettlements}
            />
            <Route
              path="/back-office/settlement-rule-configs"
              component={SettlementRuleConfigs}
            />
            <Route
              path="/front-office/bulk-settlements"
              component={FrontOfficeBulkSettlement}
            />
            <Route
              path="/front-office/super-agent-users"
              component={FrontOfficeSuperAgentUsers}
            />
            <Route path="/back-office/super-agents" component={SuperAgents} />
            <Route
              path="/back-office/disputes/backoffice"
              component={BackofficeDisputes}
            />
            <Route
              path="/back-office/disputes/super-agents"
              component={BackofficeSuperagentDisputes}
            />
            <Route
              path="/back-office/disputes/pending-manual-refunds"
              component={ManualDisputeRefunds}
            />
            <Route
              path="/back-office/disputes/pending-manual-settlements"
              component={ManualSettlementPayments}
            />
            <Route
              path="/front-office/agent-disputes"
              component={FrontOfficeAgentDisputes}
            />
            <Route
              path="/front-office/bank-disputes"
              component={FrontOfficeBankDisputes}
            />
            <Route
              path="/front-office/bulk-dispute-response"
              component={BulkDisputeResponse}
            />
            <Route
              path="/back-office/super-agent-users"
              component={SuperAgentUsers}
            />
            <Route path="/back-office/charge-types" component={ChargeTypes} />
            <Route
              path="/back-office/settlement-participants"
              component={Participants}
            />
            <Route
              path="/back-office/public-holidays"
              component={PublicHolidays}
            />
            <Route
              path="/back-office/configurations"
              component={Configurations}
            />
            <Route path="/account/change-password" component={ChangePassword} />
            <Route
              path="/back-office/user-management"
              component={UserManagement}
            />
            <Route
              path="/back-office/participant-users"
              component={ParticipantUsers}
            />
            <Route
              path="/back-office/participant-reports"
              component={ParticipantReports}
            />
            <Route
              path="/back-office/workflow-requests/all"
              component={AllWorkflowRequests}
            />
            <Route
              path="/back-office/workflow-requests/self"
              component={SelfWorkflowRequests}
            />
            <Route
              path="/back-office/reconciliation/file-upload"
              component={UploadedReconciliationFiles}
            />
            <Route
              path="/back-office/reconciliation/daily-uploads"
              component={ReconciliationDailyUploads}
            />
            <Route
              path="/back-office/reconciliation/credit-reconciliation"
              component={CreditReconciliation}
            />
            <Route
              path="/back-office/reconciliation/debit-reconciliation"
              component={DebitReconciliation}
            />
            <Route
              path="/back-office/reconciliation/configurations"
              component={ReconciliationConfigurations}
            />
            <Route path="/back-office/bulk-disputes" component={BulkDisputes} />
            <Route
              path="/back-office/transit-accounts"
              component={TransitAccounts}
            />
            {/* Application Monitoring */}
            {/* <Route
              path="/monitoring/dcir-services"
              component={DcirServicesMonitoring}
            />
            <Route
              path="/monitoring/fep-processing-metrics"
              component={FepProcessingMetrics}
            />
            <Route
              path="/monitoring/server-health"
              component={ServerHealthMonitoring}
            /> */}
            <Route path="**" component={PageNotFound} />
          </Switch>
        </div>
      </div>
    </div>
  );
};
